import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from 'react';
import { useListContext } from 'react-admin';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { api, getListAPI } from '../../../services';
import {
  stringify,
  formatDateDDMMYYYYHHmm,
  SECONDARY_COLOR,
  saveAs,
} from '../../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    // color: theme.palette.grey[500],
    color: 'white',
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: SECONDARY_COLOR,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const perPage = 10;

const DialogoDesagendar = forwardRef(({ handleClose = () => {} }, ref) => {
  const [open, setOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const listContext = useListContext();
  const { ids, filterValues, setFilters, displayedFilters } = listContext;

  const [carregando, setCarregando] = useState(false);

  const [page, setPage] = useState(0);

  const [total, setTotal] = useState(0);
  const [dados, setDados] = useState([]);

  const classes = useStyles({ cor: '#009FD4' });

  const handleCloseDialog = () => {
    setOpen(false);
    handleClose();
  };

  function formatDados(dados) {
    const dadosFortamados = [];
    for (let i = 0; i < dados.length; i++) {
      dadosFortamados.push({
        id: dados[i].id,
        data_inicio: formatDateDDMMYYYYHHmm(dados[i].data_inicio),
        data_fim: formatDateDDMMYYYYHHmm(dados[i].data_fim),
        status: dados[i].status ? 'PROCESSADO' : 'NÃO PROCESSADO',
        status_original: dados[i].status,
      });
    }
    return dadosFortamados;
  }

  async function getDataResource(page) {
    try {
      const data = await getListAPI(
        'status_processamento_excel_transacao',
        ['id', 'desc'],
        [page + 1, perPage],
        {},
        [],
      );
      setDados(formatDados(data.data));
      setTotal(data.total);
      setCarregando(false);
    } catch (erros) {
      setDados([]);
      setCarregando(false);
      enqueueSnackbar(`${erros}`, {
        variant: 'error',
      });
      handleCloseDialog();
    }
  }

  useImperativeHandle(ref, () => ({
    handleOpen() {
      setOpen(true);
    },
  }));

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (open) {
      getDataResource(page);
    }
  }, [page, open]);

  function formatDataAtual() {
    return `Relatorio_Transacoes_${moment(new Date()).format(
      'DD/MM/YYYY-HH:mm',
    )}.xlsx`;
  }

  function baixarArquivo(id) {
    saveAs(
      `${process.env.REACT_APP_HOST_API}/baixar_relatorio_excel_transacoes/${id}`,
      formatDataAtual(),
    );
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function novoRelatorio() {
    api.get(
      `/transacoes_excel_processando?${stringify({
        filter: JSON.stringify({
          tipo: filterValues.tipo,
          categorias: filterValues.categorias,
          contas: filterValues.contas,
          situacoes: filterValues.situacoes,
          tipos: filterValues.tipos,
          periodo: filterValues.periodo,
          search: filterValues.search,
          periodo2: filterValues.periodo2,
          inverso: filterValues.inverso,
          categorias_problemas: filterValues.categorias_problemas,
          agendamento: filterValues.agendamento,
        }),
      })}`,
    );
    await sleep(1000);
    getDataResource(page);
    enqueueSnackbar(`Relatório em Processamento`, {
      variant: 'info',
    });
  }

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="form-dialog-title"
        classes={{ paper: classes.rootDialogo }}
        className={classes.rootDialogo}
        fullWidth
        maxWidth="md"
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle
          id="form-dialog-title"
          onClose={handleCloseDialog}
          style={{ backgroundColor: '#009FD4', color: 'white' }}
        >
          Status de Processamento do Excel de Transações
        </DialogTitle>
        <DialogContent
          style={{
            padding: '0px 36px 20px',
            margin: '0',
          }}
        >
          {carregando ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: '10px',
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => novoRelatorio()}
                >
                  Novo
                </Button>
              </div>
              <Box mt="1em" />
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Status</StyledTableCell>
                      <StyledTableCell>Id</StyledTableCell>
                      <StyledTableCell>Solicitação</StyledTableCell>
                      <StyledTableCell>Término Processamento</StyledTableCell>
                      <StyledTableCell>Ações</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dados.map((row) => (
                      <StyledTableRow key={row.id}>
                        <StyledTableCell>{row.status}</StyledTableCell>
                        <StyledTableCell>{row.id}</StyledTableCell>
                        <StyledTableCell>{row.data_inicio}</StyledTableCell>
                        <StyledTableCell>{row.data_fim}</StyledTableCell>
                        <StyledTableCell>
                          <IconButton
                            aria-label="download"
                            size="small"
                            onClick={() => baixarArquivo(row.id)}
                            disabled={!row.status_original}
                          >
                            <GetAppIcon />
                          </IconButton>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[perPage]}
                  count={total}
                  rowsPerPage={perPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={() => {}}
                  labelRowsPerPage="Por página"
                  labelDisplayedRows={({ from, to, count }) =>
                    `${from}-${to} de ${
                      count !== -1 ? count : `more than ${to}`
                    }`
                  }
                />
              </TableContainer>
            </div>
          )}
        </DialogContent>
        <DialogActions
          style={{
            padding: '0px 36px 20px',
            margin: '0',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Button
            onClick={handleCloseDialog}
            classes={{
              root: classes.btnAtions,
              disabled: classes.btnAtionsDisabled,
            }}
            variant="contained"
            color="primary"
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

export default DialogoDesagendar;
